import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import AnalyticsTooltip from "src/components/Referral-partner/Analytics/AnalyticsTooltip";
import { TimeSeriesDataPoint } from "src/components/Referral-partner/Analytics/analyticsTypes";
import { AXIS_STYLES, GRID_STYLES } from "../styles/chart.styles";

interface DepositVolumeProps {
  data: TimeSeriesDataPoint[];
}
const DepositVolume = (props: DepositVolumeProps) => {
  const { data } = props;

  const formatYAxis = (value: number): string => {
    if (value === 0) return "0";
    if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
    if (value >= 1000) return `${(value / 1000).toFixed(0)}k`;
    return value.toString();
  };

  const legendFormatter = (value: any) => {
    return value.split(" (")[0];
  };

  return (
    <ResponsiveContainer id="deposit-volume-chart" height="80%" width="100%">
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 10,
        }}>
        <CartesianGrid vertical={false} {...GRID_STYLES} />
        <XAxis dataKey="timestamp" textAnchor="end" {...AXIS_STYLES} />
        <YAxis tickFormatter={formatYAxis} {...AXIS_STYLES} />
        <Tooltip content={<AnalyticsTooltip chartName="depositVolume" />} />
        <Legend
          verticalAlign="bottom"
          height={25}
          iconSize={10}
          wrapperStyle={{
            fontSize: "10px",
          }}
          formatter={legendFormatter}
        />
        <Bar dataKey="Crypto Deposits" stackId="a" fill="#a0cfdd" />
        <Bar dataKey="Fiat Deposits" stackId="a" fill="#ffae58" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DepositVolume;
